import type { ComponentProps } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { CheckoutJourneyTabs } from '@/components/billing/CheckoutJourneyTabs';
import { usePricingDisplayCatalog } from '@/hooks/usePricingDisplay';
import { supabase } from '@/integrations/supabase/client';
import { seekSupabase } from '@/integrations/supabase/seekClient';
import { planIntroPricing, planPricingForCycle } from '@/lib/billing/pricingDisplay';

type CheckoutPurchaseDialogProps = ComponentProps<typeof CheckoutJourneyTabs> & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CheckoutPurchaseDialog({
  open,
  onOpenChange,
  ...checkoutProps
}: CheckoutPurchaseDialogProps) {
  const client = checkoutProps.platform === 'forkseek' ? seekSupabase : supabase;
  const {
    data: pricingCatalog,
    isLoading: pricingLoading,
    isFetching: pricingFetching,
    isError: pricingError,
  } = usePricingDisplayCatalog(client, checkoutProps.platform, open);
  const renewalPricing = planPricingForCycle(
    pricingCatalog,
    checkoutProps.planId,
    checkoutProps.billingCycle,
  );
  const introPricing = checkoutProps.billingCycle === 'monthly'
    ? planIntroPricing(pricingCatalog, checkoutProps.planId)
    : null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto border-0 bg-transparent p-0 shadow-none sm:rounded-xl">
        <CheckoutJourneyTabs
          {...checkoutProps}
          introPricing={introPricing}
          renewalPricing={renewalPricing}
          pricingLoading={pricingLoading || pricingFetching}
          pricingError={pricingError}
          priceAvailable={checkoutProps.priceAvailable && Boolean(introPricing ?? renewalPricing) && Boolean(renewalPricing)}
        />
      </DialogContent>
    </Dialog>
  );
}
